module.exports = __webpack_public_path__ + "img/align-center.03d896b6.svg";